// extracted by mini-css-extract-plugin
export default {"couponBox":"ModalApplyCoupon_couponBox__J-cJn","urlButton":"ModalApplyCoupon_urlButton__XpR95"};